import { render, staticRenderFns } from "./ForgottenPasswordBox.vue?vue&type=template&id=0f56527d&scoped=true&"
import script from "./ForgottenPasswordBox.vue?vue&type=script&lang=js&"
export * from "./ForgottenPasswordBox.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPasswordBox.vue?vue&type=style&index=0&id=0f56527d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f56527d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f56527d')) {
      api.createRecord('0f56527d', component.options)
    } else {
      api.reload('0f56527d', component.options)
    }
    module.hot.accept("./ForgottenPasswordBox.vue?vue&type=template&id=0f56527d&scoped=true&", function () {
      api.rerender('0f56527d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/ForgottenPasswordBox.vue"
export default component.exports